import { render } from "./supervisorList.vue?vue&type=template&id=1b36d1af&scoped=true"
import script from "./supervisorList.vue?vue&type=script&lang=js"
export * from "./supervisorList.vue?vue&type=script&lang=js"

import "./supervisorList.vue?vue&type=style&index=0&id=1b36d1af&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b36d1af"]])

export default __exports__